module.exports = __webpack_public_path__ + "img/184.ef87c1ba.jpg";